import { axios } from '@/utils/request'

//获取字典
export function getDict(dictName){
    return axios({
        url:"/sys/dict/getDictItems/" + dictName,
        method: 'get',
    })
}

//获取公告
export function getAnnountCement(){
    return axios({
        url: "/sys/annountCement/listPublicAnnouncement",
        method: 'get'
    })
}